"use client";

import type { SharedItem } from "@v1/native";

/**
 * Content shared into the store app, parked until the screen that takes it
 * (Ablage upload, portal "Neues Anliegen") is mounted. In-memory only.
 */
let pending: SharedItem | null = null;
const listeners = new Set<() => void>();

export function setPendingShare(item: SharedItem): void {
  pending = item;
  for (const listener of listeners) listener();
}

export function hasPendingShare(): boolean {
  return pending !== null;
}

/**
 * Hand the parked item to `take` once — now if present, else when it arrives.
 * Returns the unsubscribe for effect cleanup.
 */
export function consumePendingShare(
  take: (item: SharedItem) => void,
): () => void {
  const deliver = (): void => {
    if (pending === null) return;
    const item = pending;
    pending = null;
    take(item);
  };
  deliver();
  listeners.add(deliver);
  return () => {
    listeners.delete(deliver);
  };
}
